export enum OTPChannelTypes {
  EMAIL = 'CHANNEL_EMAIL',
  SMS = 'CHANNEL_SMS',
  WHATSAPP = 'CHANNEL_WHATSAPP',
  UNSPECIFIED = 'CHANNEL_UNSPECIFIED',
  PROMPT = 'CHANNEL_PROMPT',
}

export enum BasicChallenges {
  INITIAL = 'CHALLENGE_INITIAL_OTP',
  OTP = 'CHALLENGE_OTP',
  VERIFY_OTP = 'CHALLENGE_VERIFY_OTP',
  FINISHED = 'CHALLENGE_FINISH',
  FACE_MATCHING = 'CHALLENGE_FACE_MATCHING',
  CURRENT_PASSWORD = 'CHALLENGE_CURRENT_PASSWORD',
  REQUEST_NEW_PASSWORD = 'CHALLENGE_REQUEST_NEW_PASSWORD',
  CONFIRM_NEW_PASSWORD = 'CHALLENGE_CONFIRM_NEW_PASSWORD',
  IDENTITY = 'CHALLENGE_IDENTITY',
  REQUEST_NEW_EMAIL = 'CHALLENGE_REQUEST_NEW_EMAIL',
  NEW_EMAIL_OTP = 'CHALLENGE_NEW_EMAIL_OTP',
  REQUEST_NEW_PHONE_NUMBER = 'CHALLENGE_REQUEST_NEW_PHONE_NUMBER',
  NEW_PHONE_NUMBER_OTP = 'CHALLENGE_NEW_PHONE_NUMBER_OTP',
}

export enum ChallengePINStates {
  INITIAL = 'CHALLENGE_INITIAL_OTP',
  IDENTITY = 'PIN_MUTATION_STATE_IDENTITY',
  OTP = 'PIN_MUTATION_STATE_OTP',
  FACE_MATCHING = 'PIN_MUTATION_STATE_FACE_MATCHING',
  PIN_CREATION = 'PIN_MUTATION_STATE_PIN_CREATION',
  PIN_CONFIRMATION = 'PIN_MUTATION_STATE_PIN_CONFIRMATION',
  COMPLETED = 'PIN_MUTATION_STATE_COMPLETED',
  CURRENT_PIN = 'PIN_MUTATION_STATE_CURRENT_PIN',
}
export interface IBasicOTPResponse<T = any> {
  next_state: T;
  supporting_data?: {
    otp?: {
      default_channel: OTPChannelTypes;
      channels: {
        channel: OTPChannelTypes;
        target: string;
      }[];
    };
  };
}

export interface IChallengeOTPResponse<T = any>
  extends Omit<IBasicOTPResponse, 'next_state'> {
  next_challenge: T;
}

export interface IOTPResponse<T = any> extends IBasicOTPResponse<T> {
  token: string;
}
export interface IOTPResponseWithSessionToken<T = any>
  extends IBasicOTPResponse<T> {
  session_token: string;
}

export interface ISendOTPResponse {
  session_token?: string;
  token?: string;
  next_attempt_in: number;
  target: string;
  channel?: OTPChannelTypes;
}
